import { EntityListItem } from 'elements/eventView/atomic/EntityListItem';
import { motion } from 'framer-motion';
import { useIsWide } from 'libs/utils/logic/ui/responsiveLogic';
import { useContext } from 'react';
import { CtxEventView } from 'session/ctxEventView';
import styled, { css } from 'styled-components/macro';

interface Props {
    className?: string;
    entity: string;
    entityId: string;
    entityListAlign?: 'left' | 'center';
}

export const EventViewEntityListPageContent = (props: Props) => {
    const ctxEventView = useContext(CtxEventView);
    const { eventPath } = ctxEventView;
    const isWide = useIsWide();

    const { entityId, entity } = props;

    const { allStories } = ctxEventView;

    const getListIds = () => {
        if (entity === 'program') {
            return ctxEventView.allPrograms.find((e) => e.programId === entityId)?.storyIds ?? [];
        }
    };

    const isSpeakerList = entityId === ctxEventView.eventData?.programSettings?.speakersListId;

    const list = getListIds()
        ?.map((storyId) => allStories.find((e) => e.storyId === storyId))
        ?.filter(Boolean);

    if (!list?.length) {
        return null;
    }

    return (
        <S_EVEntityPageContent className={props.className}>
            <S_EntityList $isWide={isWide} $align={props.entityListAlign ?? 'left'}>
                {list.map((entity) => {
                    return (
                        <S_EntityListItem
                            key={entity.storyId}
                            entity={entity}
                            showDescription={isSpeakerList}
                            mobilePathTo={`/event/${eventPath}/${props.entity}`}
                            $isWide={isWide}
                        />
                    );
                })}
            </S_EntityList>
        </S_EVEntityPageContent>
    );
};

const S_EVEntityPageContent = styled(motion.div)`
    width: 100%;
`;

const S_EntityList = styled.div<{ $isWide: boolean; $align: 'left' | 'center' }>`
    display: flex;
    flex-direction: row;
    gap: 10px;
    flex-wrap: wrap;
    ${(props) => {
        if (props.$isWide) {
            return css`
                gap: 20px;
            `;
        }
    }}

    ${(props) => {
        if (props.$align === 'center') {
            return css`
                justify-content: center;
            `;
        }
    }}
`;

const S_EntityListItem = styled(EntityListItem)<{ $isWide: boolean }>`
    width: calc(50% - 5px);
    min-height: 160px;
    ${(props) => {
        if (props.$isWide) {
            return css`
                width: 235px;
                // For embedded page, this fixes the max-width
                max-width: 45%;
                min-height: 221px;
            `;
        }
    }}
`;
